/* ============================================
   HAYPER HYDE — PDP Patch JS (FINAL)
   File: assets/pdp-patch.js
   - Cambio patch ISTANTANEO (zero fetch, come la base)
   - Mantiene base cap selezionata
   - Toggle, add-to-cart bundle, carosello upsell
   ============================================ */

(function () {
  'use strict';

  var HH = window.__HH_STATE__ || { selectedCap: null };
  window.__HH_STATE__ = HH;

  /* ─── HELPER SICURI per webview (Instagram/TikTok in-app browser) ─── */
  /* Questi webview bloccano history API, sandbox, ecc. Avvolgiamo tutto
     in try/catch così se una chiamata è vietata, la pagina NON crasha. */
  function safePushState(state, url) {
    try { history.pushState(state, '', url); } catch (e) {}
  }
  function safeReplaceState(state, url) {
    try { history.replaceState(state, '', url); } catch (e) {}
  }
  function safeSetTitle(t) {
    try { document.title = t; } catch (e) {}
  }
  function safeGetParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    } catch (e) {
      // fallback manuale se URLSearchParams non è disponibile
      try {
        var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
        return match ? decodeURIComponent(match[1]) : null;
      } catch (e2) { return null; }
    }
  }

  var section, composer, patchPrice, patchVariantId;

  function $(sel) { return section ? section.querySelector(sel) : null; }
  function $all(sel) { return section ? Array.prototype.slice.call(section.querySelectorAll(sel)) : []; }

  function refreshRefs() {
    section = document.querySelector('.pdp-patch-section');
    if (!section) return false;
    composer = section.querySelector('#pdp-composer');
    patchPrice = parseFloat(section.dataset.patchPrice) || 0;
    patchVariantId = section.dataset.patchVariantId;
    return true;
  }

  /* ─── TOGGLE Sul cap / Solo patch ─── */
  function bindToggles() {
    $all('.pdp-patch__toggle button').forEach(function (btn) {
      btn.onclick = function () {
        var view = btn.dataset.view;
        $all('.pdp-patch__toggle button').forEach(function (b) {
          b.classList.toggle('active', b.dataset.view === view);
        });
        if (!composer) return;
        if (view === 'patch-only') {
          composer.classList.add('patch-only');
          composer.classList.remove('no-cap');
        } else {
          composer.classList.remove('patch-only');
          if (!HH.selectedCap) composer.classList.add('no-cap');
        }
      };
    });
  }

  /* ─── AUTO-SCROLL al compositore su mobile/tablet ─── */
  function scrollToComposerIfMobile() {
    if (window.innerWidth > 1024) return;
    if (!composer) return;
    var rect = composer.getBoundingClientRect();
    // calcola offset tenendo conto di un eventuale header sticky (80px)
    var targetY = window.pageYOffset + rect.top - 80;
    try {
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, targetY);
    }
  }

  /* ─── SELEZIONE BASE ─── */
  function applyCapSelection(capEl) {
    if (!capEl || !composer) return;
    var capColor = capEl.dataset.capColor;
    $all('.pdp-patch__cap').forEach(function (img) {
      img.classList.toggle('active', img.dataset.cap === capColor);
    });
    composer.classList.remove('no-cap', 'patch-only');
    $all('.pdp-patch__toggle button').forEach(function (b) {
      b.classList.toggle('active', b.dataset.view === 'composed');
    });
    $all('.pdp-patch__base').forEach(function (b) {
      b.classList.toggle('active', b === capEl);
    });
    HH.selectedCap = {
      variantId: capEl.dataset.capVariantId,
      name: capEl.dataset.capName,
      price: parseFloat(capEl.dataset.capPrice) || 0,
      capColor: capColor
    };
    updateSelectedName();
    updatePrice();
    updateCTA();
    var clearBtn = $('.pdp-patch__clear-base');
    if (clearBtn) clearBtn.classList.remove('hidden');
  }

  function clearCap() {
    HH.selectedCap = null;
    $all('.pdp-patch__cap').forEach(function (img) { img.classList.remove('active'); });
    $all('.pdp-patch__base').forEach(function (b) { b.classList.remove('active'); });
    if (composer) {
      composer.classList.add('no-cap');
      composer.classList.remove('patch-only');
    }
    $all('.pdp-patch__toggle button').forEach(function (b) {
      b.classList.toggle('active', b.dataset.view === 'composed');
    });
    updateSelectedName();
    updatePrice();
    updateCTA();
    var clearBtn = $('.pdp-patch__clear-base');
    if (clearBtn) clearBtn.classList.add('hidden');
  }

  function bindBases() {
    $all('.pdp-patch__base').forEach(function (capEl) {
      capEl.onclick = function () {
        if (HH.selectedCap && HH.selectedCap.capColor === capEl.dataset.capColor) {
          clearCap();
        } else {
          applyCapSelection(capEl);
          scrollToComposerIfMobile();
        }
      };
    });
  }

  function bindClearBase() {
    var clearBtn = $('.pdp-patch__clear-base');
    if (clearBtn) clearBtn.onclick = clearCap;
  }

  function updateSelectedName() {
    var el = $('.pdp-patch__selected-name');
    if (el) el.textContent = HH.selectedCap ? HH.selectedCap.name : '—';
  }

  function updatePrice() {
    var priceEl = $('#pdp-price');
    var noteEl = $('#pdp-price-note');
    var total = patchPrice + (HH.selectedCap ? HH.selectedCap.price : 0);
    if (priceEl) priceEl.textContent = '€' + total;
    if (noteEl) {
      noteEl.textContent = HH.selectedCap
        ? ('Patch €' + patchPrice + ' + Cap ' + HH.selectedCap.name + ' €' + HH.selectedCap.price)
        : 'Patch · Cap opzionale';
    }
  }

  function updateCTA() {
    var cta = $('.pdp-patch__cta');
    if (!cta) return;
    var total = patchPrice + (HH.selectedCap ? HH.selectedCap.price : 0);
    cta.textContent = 'Aggiungi al carrello · €' + total;
  }

  function bindCTA() {
    var cta = $('.pdp-patch__cta');
    if (!cta) return;
    cta.onclick = function () {
      var items = [{ id: patchVariantId, quantity: 1 }];
      if (HH.selectedCap) items.push({ id: HH.selectedCap.variantId, quantity: 1 });
      addItemsToCart(items, cta);
    };
  }

  function bindExpand() {
    var expandBtn = $('#pdp-variant-expand');
    var selector = $('#pdp-variant-selector');
    if (expandBtn && selector) {
      expandBtn.onclick = function () { selector.classList.add('expanded'); };
    }
  }

  /* ─── CAMBIO PATCH ISTANTANEO (zero fetch) ─── */
  function bindPatchSwitch() {
    var grid = $('#pdp-variant-grid');
    if (!grid) return;
    grid.onclick = function (e) {
      var item = e.target.closest('.pdp-patch__variant-item');
      if (!item) return;
      e.preventDefault();
      if (item.classList.contains('active')) return;
      switchPatch(item);
    };
  }

  function switchPatch(item) {
    // Leggi i dati della nuova patch dai data-attribute (già nel DOM)
    var newVariantId = item.dataset.patchVariantId;
    var newTitle = item.dataset.patchTitle || '';
    var newArchetype = item.dataset.patchArchetype || '';
    var newPrice = parseFloat(item.dataset.patchPrice) || patchPrice;
    var newImg = item.dataset.patchImg;
    var newUrl = item.dataset.patchUrl;

    // 1. Aggiorna immagine patch nel compositore (istantaneo)
    var patchImg = $('#pdp-patch-img');
    if (patchImg && newImg) {
      patchImg.src = newImg;
      patchImg.alt = newTitle;
    }

    // 2. Aggiorna titolo
    var titleEl = $('#pdp-title');
    if (titleEl) {
      var emHtml = newArchetype ? '<em>' + newArchetype + '</em>' : '';
      titleEl.innerHTML = newTitle + ' ' + emHtml;
    }

    // 3. Aggiorna nome patch corrente nel selettore
    var currentName = $('#pdp-current-patch-name');
    if (currentName) currentName.textContent = newTitle;

    // 4. Aggiorna stato attivo nella griglia
    $all('.pdp-patch__variant-item').forEach(function (el) {
      el.classList.toggle('active', el === item);
    });

    // 5. Aggiorna prezzo base patch + variant id
    patchPrice = newPrice;
    patchVariantId = newVariantId;
    section.dataset.patchPrice = newPrice;
    section.dataset.patchVariantId = newVariantId;

    // 6. Ricalcola prezzo totale e CTA (con eventuale cap selezionato)
    updatePrice();
    updateCTA();

    // 7. Aggiorna URL nel browser senza reload
    if (newUrl) {
      safePushState({ patchUrl: newUrl }, newUrl);
      safeSetTitle(newTitle + ' — Hayper Hyde');
    }

    // 8. Scroll al compositore su mobile/tablet
    scrollToComposerIfMobile();

    // NB: descrizione e lore NON si aggiornano (sono fuori dall'hero).
    // Restano quelli della patch caricata inizialmente: vedi nota sotto.
  }

  // back/forward browser: ricarica (per avere descrizione/lore corretti)
  window.addEventListener('popstate', function () {
    try { window.location.reload(); } catch (e) {}
  });

  /* ─── FAQ ACCORDION ─── */
  function bindFAQ() {
    document.querySelectorAll('.pdp-patch__faq-item').forEach(function (item) {
      var q = item.querySelector('.pdp-patch__faq-q');
      if (!q) return;
      q.style.cursor = 'pointer';
      q.onclick = function () {
        var isOpen = item.classList.contains('open');
        // chiudi tutti
        document.querySelectorAll('.pdp-patch__faq-item.open').forEach(function (el) {
          el.classList.remove('open');
        });
        // apri quello cliccato se era chiuso
        if (!isOpen) item.classList.add('open');
      };
    });
  }

  /* ─── CAROSELLO UPSELL — mobile-safe ─── */
  function initCarousel() {
    var carousel = document.querySelector('#pdp-upsell-carousel');
    if (!carousel) return;
    var track = carousel.querySelector('.pdp-upsell__track');
    var prevBtn = document.querySelector('.pdp-upsell__nav--prev');
    var nextBtn = document.querySelector('.pdp-upsell__nav--next');
    if (!track) return;

    var isDesktop = window.innerWidth > 1024;

    // Re-bind add-to-cart su tutte le card presenti
    function bindAddButtons() {
      carousel.querySelectorAll('.pdp-upsell__add').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          var vid = btn.dataset.variantId;
          if (vid) addItemsToCart([{ id: vid, quantity: 1 }], btn);
        };
      });
    }

    // Loop infinito + scroll su tutte le risoluzioni.
    // Drag col mouse solo su desktop; su mobile lo scroll col dito è nativo.
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-upsell-card]'));
    if (cards.length === 0) { bindAddButtons(); return; }

    // Duplica le card per il loop infinito (tutte le ~100 patch)
    cards.forEach(function (c) {
      var clone = c.cloneNode(true);
      clone.setAttribute('data-clone', 'true');
      track.appendChild(clone);
    });

    bindAddButtons();

    var loopWidth = 0;
    function recalcLoopWidth() { loopWidth = track.scrollWidth / 2; }
    recalcLoopWidth();
    window.addEventListener('resize', recalcLoopWidth);

    // Loop con guardia anti auto-trigger (niente setTimeout che forza lo scroll)
    var isJumping = false;
    track.addEventListener('scroll', function () {
      if (isJumping || loopWidth === 0) return;
      if (track.scrollLeft >= loopWidth) {
        isJumping = true;
        track.scrollLeft = track.scrollLeft - loopWidth;
        requestAnimationFrame(function () { isJumping = false; });
      } else if (track.scrollLeft <= 0) {
        isJumping = true;
        track.scrollLeft = loopWidth - 2;
        requestAnimationFrame(function () { isJumping = false; });
      }
    }, { passive: true });

    // Frecce
    if (nextBtn) {
      nextBtn.onclick = function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); };
    }
    if (prevBtn) {
      prevBtn.onclick = function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); };
    }

    // Drag col mouse — solo desktop (mobile usa scroll touch nativo)
    if (isDesktop) {
      var isDragging = false, startX = 0, startScroll = 0, hasDragged = false;
      track.addEventListener('mousedown', function (e) {
        if (e.target.closest('.pdp-upsell__add')) return;
        isDragging = true;
        hasDragged = false;
        startX = e.pageX;
        startScroll = track.scrollLeft;
        track.style.cursor = 'grabbing';
        track.style.userSelect = 'none';
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 5) hasDragged = true;
        track.scrollLeft = startScroll - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        track.style.cursor = '';
        track.style.userSelect = '';
        if (hasDragged) {
          var blockClick = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            track.removeEventListener('click', blockClick, true);
          };
          track.addEventListener('click', blockClick, true);
        }
      });
      track.style.cursor = 'grab';
    }
  }

  /* ─── ADD TO CART (aggiorna drawer Horizon senza reload) ─── */
  function addItemsToCart(items, btnEl) {
    var originalText = btnEl ? btnEl.textContent : '';
    if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Aggiunta...'; }

    // 1. Aggiungi al carrello, chiedendo a Shopify di restituire le sezioni del drawer
    var sectionsToRender = getCartSectionIds();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // 2. Re-inietta l'HTML aggiornato delle sezioni carrello nel DOM
        if (data && data.sections) {
          Object.keys(data.sections).forEach(function (id) {
            updateCartSection(id, data.sections[id]);
          });
        }

        if (btnEl) {
          btnEl.textContent = '✓ Aggiunto';
          setTimeout(function () { btnEl.disabled = false; btnEl.textContent = originalText; }, 1500);
        }

        // 3. Notifica al tema e apri il drawer
        publishCartUpdate();
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('Errore carrello:', err);
        if (btnEl) { btnEl.disabled = false; btnEl.textContent = originalText; }
      });
  }

  // Raccoglie gli ID delle sezioni carrello presenti sulla pagina
  function getCartSectionIds() {
    var ids = [];
    var selectors = [
      'cart-drawer', '.cart-drawer', '#cart-drawer', '#CartDrawer',
      'cart-notification', '.cart-notification',
      '[id*="cart-drawer"]', '[id*="CartDrawer"]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var sectionEl = el.closest('.shopify-section');
        if (sectionEl && sectionEl.id) {
          var sid = sectionEl.id.replace('shopify-section-', '');
          if (ids.indexOf(sid) === -1) ids.push(sid);
        } else if (el.dataset && el.dataset.sectionId) {
          if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
        }
      });
    });
    // fallback comuni nei temi Shopify/Horizon
    ['cart-drawer', 'cart-icon-bubble', 'cart-notification'].forEach(function (sid) {
      if (ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  // Sostituisce il contenuto di una sezione carrello con l'HTML aggiornato
  function updateCartSection(sectionId, html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');

    // prova a sostituire l'intera shopify-section
    var target = document.getElementById('shopify-section-' + sectionId);
    if (target) {
      var newInner = parsed.getElementById('shopify-section-' + sectionId);
      if (newInner) {
        target.innerHTML = newInner.innerHTML;
        return;
      }
      // se la risposta è già il contenuto interno
      if (parsed.body && parsed.body.firstElementChild) {
        target.innerHTML = parsed.body.innerHTML;
        return;
      }
    }

    // fallback: aggiorna i custom element noti
    ['cart-drawer', 'cart-notification', 'cart-icon-bubble'].forEach(function (tag) {
      var existing = document.querySelector(tag);
      var fresh = parsed.querySelector(tag);
      if (existing && fresh) existing.innerHTML = fresh.innerHTML;
    });
  }

  // Notifica al tema che il carrello è cambiato (eventi standard Shopify/Horizon)
  function publishCartUpdate() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-items:updated', { bubbles: true }));
    window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    // Horizon / Dawn PUB_SUB
    if (window.Shopify && window.Shopify.PubSub) {
      try { window.Shopify.PubSub.publish('cart:update'); } catch (e) {}
    }
  }

  // Apre il drawer del carrello con i metodi noti dei temi
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer, #cart-drawer, #CartDrawer, .cart-drawer');
    if (!drawer) {
      // nessun drawer: vai al carrello
      setTimeout(function () { window.location.href = '/cart'; }, 400);
      return;
    }
    // metodi comuni
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    if (typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
    // classi/attributi comuni
    drawer.classList.add('active', 'is-open', 'open', 'drawer--active');
    drawer.setAttribute('open', '');
    drawer.removeAttribute('hidden');
    document.body.classList.add('cart-drawer-open', 'overflow-hidden');
    // trigger click su eventuale bottone apri-carrello come ultimo fallback
    var trigger = document.querySelector('[aria-controls*="cart"], [href="/cart"], .header__icon--cart');
  }

  /* ─── INIT protetto ─── */
  function init() {
    try {
      if (!refreshRefs()) return;
    } catch (e) { return; }
    try { bindToggles(); } catch (e) { console.error('toggles', e); }
    try { bindBases(); } catch (e) { console.error('bases', e); }
    try { bindClearBase(); } catch (e) { console.error('clearBase', e); }
    try { bindCTA(); } catch (e) { console.error('cta', e); }
    try { bindExpand(); } catch (e) { console.error('expand', e); }
    try { bindPatchSwitch(); } catch (e) { console.error('patchSwitch', e); }
    try { bindFAQ(); } catch (e) { console.error('faq', e); }
    try {
      // Preselezione cap da URL (?cap_vid=VARIANTID) — viene dalla redirect PDP cap
      var capVid = safeGetParam('cap_vid');
      if (capVid && !HH.selectedCap) {
        var matchEl = null;
        $all('.pdp-patch__base').forEach(function (b) {
          if (b.dataset.capVariantId === capVid) matchEl = b;
        });
        if (matchEl) {
          applyCapSelection(matchEl);
          safeReplaceState({}, window.location.pathname);
        }
      } else if (HH.selectedCap) {
        var capEl = $('.pdp-patch__base[data-cap-color="' + HH.selectedCap.capColor + '"]');
        if (capEl) applyCapSelection(capEl);
      }
    } catch (e) { console.error('restoreCap', e); }
    // Carosello: la parte più pesante. La inizializziamo DOPO il primo paint,
    // così nel webview la pagina si disegna subito e il carosello arriva dopo.
    try {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () {
          try { initCarousel(); } catch (e) { console.error('carousel', e); }
        }, { timeout: 1200 });
      } else {
        setTimeout(function () {
          try { initCarousel(); } catch (e) { console.error('carousel', e); }
        }, 300);
      }
    } catch (e) {
      try { initCarousel(); } catch (e2) {}
    }
  }

  function safeInit() {
    try { init(); } catch (e) { /* webview: non bloccare mai la pagina */ }
  }

  /* ─── FIX WEBVIEW SOSPESO (Instagram/TikTok) ─── */
  /* Il webview a volte sospende il rendering: la pagina è caricata ma
     lo schermo resta congelato finché l'utente non esce e rientra.
     Forziamo un repaint appena la pagina torna visibile. */
  function forceRepaint() {
    try {
      var body = document.body;
      if (!body) return;
      // toggle impercettibile che obbliga il browser a ridisegnare
      body.style.opacity = '0.9999';
      requestAnimationFrame(function () {
        body.style.opacity = '';
      });
      // forza ricalcolo layout
      void document.documentElement.offsetHeight;
    } catch (e) {}
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') forceRepaint();
  });
  window.addEventListener('pageshow', function () { forceRepaint(); });
  window.addEventListener('focus', function () { forceRepaint(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();